module.exports = __webpack_public_path__ + "img/fancy@2x.8695692.jpg";